const AllJobs = () => {
  return (
    <div>AllJobs</div>
  );
}

export default AllJobs;